import { Button } from '../../buttons'
import { useI18n } from '@ggs/i18n'

/**
 * @typedef {import('react-hook-form').FieldErrors} FieldErrors
 * @typedef {import('react-hook-form').FieldValues} FieldValues
 * @typedef {import('react-hook-form').Control<FieldValues>} FormControl
 */

/**
 * @typedef {Object} ClearButtonProps
 * @property {boolean} isDataLoading
 * @property {FieldErrors} errors
 * @property {function} onReset
 * @property {string=} label
 */

/**
 * Provides submit button form element.
 * @param {ClearButtonProps} props
 * @return {JSX.Element}
 */
const ClearButton = ({ isDataLoading, errors, label, onReset }) => {
  const { t } = useI18n()

  return (
    <Button
      type="reset"
      label={label || t('Clear Search')}
      variant="text"
      color={Object.keys(errors).length !== 0 ? 'error' : 'secondary'}
      buttonFields={{
        disabled: isDataLoading,
        onClick: onReset,
      }}
    />
  )
}

export default ClearButton
